import { c as _c } from "react/compiler-runtime";
import { Stack, Typography, Divider } from '@mui/material';
import { BackupPolicyType } from '@repo/api-gw-sdk';
import { isPitrPolicyType, isStandardPolicyType } from './backupPoliciesTypes';
import { SupportedResourceTypesText, highFrequencyPolicyResourceTypeLimitations } from './supportedResourceTypesText';
import { useBackupPolicyAvailableTypes } from './useBackupPolicyAvailableTypes';

// hasDisclaimerContent mirrors the policy-type branches in
// BackupPolicyTypeDescription. When the description renders nothing the
// disclaimer wrapper would otherwise emit just an empty section + a
// Divider, which surfaces in the UI as a stray horizontal line directly
// beneath the wizard stepper's own Divider.
const hasDisclaimerContent = (policyType: BackupPolicyType): boolean => policyType === BackupPolicyType.BACKUP_POLICY_TYPE_HIGH_FREQUENCY || isStandardPolicyType(policyType) || isPitrPolicyType(policyType);
export const BackupPolicySupportedDisclaimer = t0 => {
  const $ = _c(8);
  const {
    policyType
  } = t0;
  if (!hasDisclaimerContent(policyType)) {
    return null;
  }
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: "2px"
    };
    t2 = <div />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      alignItems: "center"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== policyType) {
    t4 = <Stack className="bg-(--mui-palette-background-section)" sx={t3}><BackupPolicyTypeDescription policyType={policyType} /></Stack>;
    $[3] = policyType;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Divider />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4) {
    t6 = <Stack sx={t1}>{t2}{t4}{t5}</Stack>;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};
export const BackupPolicyTypeDescription = t0 => {
  const $ = _c(8);
  const {
    policyType: t1,
    showForPitr: t2
  } = t0;
  const policyType = t1 === undefined ? BackupPolicyType.BACKUP_POLICY_TYPE_STANDARD : t1;
  const showForPitr = t2 === undefined ? true : t2;
  const resourceTypes = useBackupPolicyAvailableTypes()[policyType];
  if (policyType === BackupPolicyType.BACKUP_POLICY_TYPE_HIGH_FREQUENCY || isStandardPolicyType(policyType)) {
    const policyLabel = policyType === BackupPolicyType.BACKUP_POLICY_TYPE_HIGH_FREQUENCY ? "High-frequency" : "Standard";
    const destinationSuffix = policyType === BackupPolicyType.BACKUP_POLICY_TYPE_AWS_NATIVE_STANDARD ? " \u2022 Storing snapshots in source account" : policyType === BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_FILES ? " \u2022 Storing snapshots in source subscription" : "";
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        padding: "12px 0px"
      };
      $[0] = t3;
    } else {
      t3 = $[0];
    }
    const t4 = `${policyLabel} backup policy${destinationSuffix} • Available for `;
    const t5 = policyType === BackupPolicyType.BACKUP_POLICY_TYPE_HIGH_FREQUENCY ? highFrequencyPolicyResourceTypeLimitations : undefined;
    let t6;
    if ($[1] !== resourceTypes || $[2] !== t5) {
      t6 = <SupportedResourceTypesText resourceTypes={resourceTypes} resourceTypeLimitations={t5} />;
      $[1] = resourceTypes;
      $[2] = t5;
      $[3] = t6;
    } else {
      t6 = $[3];
    }
    let t7;
    if ($[4] !== t4 || $[5] !== t6) {
      t7 = <Typography sx={t3}>{t4}{t6}</Typography>;
      $[4] = t4;
      $[5] = t6;
      $[6] = t7;
    } else {
      t7 = $[6];
    }
    return t7;
  }
  if (showForPitr && isPitrPolicyType(policyType)) {
    let t3;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Typography align="center" className="bg-(--mui-palette-background-section)" sx={{
        padding: "12px 40px"
      }}>Point-in-time recovery backup policy.</Typography>;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    return t3;
  }
  return null;
};